import { NotificationIcon, Helpicon } from "../../../../images";
import { useLocation } from "react-router-dom";

export default function Mobile() {
  const location = useLocation();

  // Hide on /course-details/:id/checkout
  const isCheckoutPage = /^\/course-details\/[^/]+\/checkout$/.test(
    location.pathname
  );

  if (isCheckoutPage) return null; // ← hide completely on that route

  return (
    <div className="hidden md:flex justify-end items-center bg-[#FFDA440D] px-4 py-3 gap-6">
      {/* Help */}
      <div className="flex items-center gap-1 text-[#333333] text-[14px] font-medium">
        <img
          src={Helpicon}
          alt="Help Icon"
          className="w-[18px] h-[18px] object-contain"
        />
        <span>Help</span>
      </div>

      {/* Notifications */}
      <div className="flex items-center gap-1 text-[#333333] text-sm font-medium">
        <img
          src={NotificationIcon}
          alt="Notification Icon"
          className="w-[18px] h-[18px] object-contain"
        />
        <span>Notifications</span>
      </div>
    </div>
  );
}
